import type { SupportSession } from '@gat-ship/types'

export function isSupportSessionExpired(supportSession: SupportSession) {
  const now = new Date()
  const endDate = new Date(supportSession.grantedTo)
  return endDate < now
}
/**
 * Checks if the support session is for the support user.
 * @param supportSession - The support session to check.
 * @param userId - The ID of the user to check.
 * @returns True if the support session is for the support user, false otherwise.
 */
export function isSupportSessionAssignedToSupportUser(
  supportPersonUserId: string,
  userId: string
) {
  return supportPersonUserId === userId
}

/**
 * Checks if the support session is owned by the user.
 * @param requestedByUserId - The ID of the user that requested the support session.
 * @param userId - The ID of the user to check.
 * @returns True if the support session is owned by the user, false otherwise.
 */
export function isSupportSessionOwnedByUser(
  requestedByUserId: string,
  userId: string
) {
  return requestedByUserId === userId
}
